/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-20T16:31:52-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-21T14:13:55-07:00
*/

import React, { Component } from 'react';
import glamorous from 'glamorous';
import MsgHeader from './MsgHeader';
import MsgActivity from './MsgActivity';
import MsgComposer from './MsgComposer';
import { dimensions, spacing } from '../../../style';
import Container from '../../blocks/Container';

const ConvoScreen = glamorous.div({
  boxSizing: 'border-box',
  height: '100vh',

  [dimensions.SCREEN_MIN_SM]: {
    height: 'calc(100vh - 65px)',
    marginTop: '65px',
  }
});

const ConvoContainer = glamorous.div({
  height: '100%'
});

const ConvoActivity = glamorous.div({
  boxSizing: 'border-box',
  height: 'calc(100vh - 69px)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',

  [dimensions.SCREEN_MIN_SM]: {
    height: `calc(100vh - ${64 + 60 + (11*2)}px)`, //really bad static values: ${topNavHeight + MsgHeaderHeight (ConvoContainerPadding * 2)}
  }
});

class MsgConvoScreen extends Component {
  render() {
    const {
      convo,
      userId,
      myAvatar,
      routeParams,
      toggleBlock,
      deleteMail,
      canMsg,
      spamFlagged,
      submitMessage,
      sex
    } = this.props

    if(convo.item.other_profile) {
      // data ready for render
      return (
        <ConvoScreen>
            <ConvoContainer>
              <MsgHeader
                username={routeParams.username}
                toggleBlock={toggleBlock}
                deleteMail={deleteMail}
                profile={convo.item.other_profile.data}
                isAdmin={Boolean(convo.item.account.data.is_admin)}
              />
              <ConvoActivity>
                <MsgActivity
                  messages={convo.item.messages.data}
                  account={convo.item.account.data}
                  profile={convo.item.other_profile.data}
                  userId={userId}
                  myAvatar={myAvatar}
                />
                <MsgComposer
                  canMsg={canMsg}
                  spamFlagged={spamFlagged}
                  sex={sex}
                  submitMessage={submitMessage}
                  username={this.props.params.username}
                />
              </ConvoActivity>
            </ConvoContainer>
        </ConvoScreen>
      );
    } else {
      return (
        // waiting for convo data.
        <div />
      )
    }
  }
}



export default MsgConvoScreen;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgConvoScreen.jsx